import { useState } from "react";

/**
 * Client-side pagination over an already-filtered list.
 * Clamps the page during render so a shrinking list (e.g. after a search)
 * never lands on an out-of-range, empty page — no effect, no flicker.
 */
export function usePagination<T>(items: T[], pageSize = 10) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const start = (safePage - 1) * pageSize;
  const pageItems = items.slice(start, start + pageSize);
  return {
    page: safePage,
    totalPages,
    pageItems,
    rangeStart: items.length === 0 ? 0 : start + 1,
    rangeEnd: start + pageItems.length,
    prev: () => setPage((p) => Math.max(1, Math.min(p, totalPages) - 1)),
    next: () => setPage((p) => Math.min(totalPages, p + 1)),
  };
}
